module.exports = __webpack_public_path__ + "img/icon-sb-logo-illustration.a2573ae.svg";